import { ShootingStars } from "core/components/global/background/stars/shooting-stars";
import { StarsBackground } from "core/components/global/background/stars/stars-background";
export default function PageNotFound() {
  return (
    <div className="h-100 bg-neutral-900 flex flex-col items-center justify-center relative w-full">
      <div className="relative flex-col md:flex-row z-10 text-3xl md:text-5xl md:leading-tight max-w-5xl mx-auto text-center tracking-tight font-medium bg-clip-text text-transparent bg-gradient-to-b from-neutral-800 via-white to-white flex items-center gap-2 md:gap-8">
        <span>404</span>
        <span className="text-white text-lg font-thin">x</span>
        <span>Not Found</span>
      </div>
      <ShootingStars />
      <StarsBackground />
    </div>
  );
}
